import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "measure-one-modal-content" }
const _hoisted_2 = { class: "measureone-container" }
const _hoisted_3 = {
  key: 0,
  class: "link-container mt-11"
}

import { ref, computed, onMounted, onUnmounted } from "vue";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import Modal from "@/components/shared/Modal.vue";
import MeasureOneWidget from "@/components/widgets/MeasureOneWidget.vue";

interface Props {
  stip: Stipulation;
  applicant: Applicant;
  lenderId: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MeasureOneModal',
  props: {
    stip: {},
    applicant: {},
    lenderId: {}
  },
  emits: ["close", "success", "confirmManualCertification"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const m1Widget = ref<InstanceType<typeof MeasureOneWidget> | null>();

const emit = __emit;

const loading = computed<boolean>(() => {
  if (m1Widget.value) {
    return m1Widget.value.loading;
  }
  return false;
});

const allowCloseBtn = computed<boolean>(() => m1Widget.value?.currentProgress === 100);

const closeModal = () => {
  emit("close");
};

function handleSuccess() {
  emit("success");
  closeModal();
}

function handleClickOutside(event: any) {
  if ((event.target as HTMLElement)?.className.includes("modal-wrapper")) {
    closeModal();
  }
}

onMounted(() => {
  // Event listener for clicks on the document
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

__expose({
  loading,
  allowCloseBtn,
  closeModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    id: "measure-one-modal",
    closeBtn: true,
    onClose: closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(MeasureOneWidget, {
            ref_key: "m1Widget",
            ref: m1Widget,
            lenderId: __props.lenderId,
            applicant: __props.applicant,
            stipulationId: __props.stip.id,
            onSuccess: handleSuccess,
            onDatasourceConnected: closeModal
          }, null, 8, ["lenderId", "applicant", "stipulationId"])
        ]),
        (!loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("a", {
                class: "text-decoration-underline",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirmManualCertification')))
              }, "Click here to submit income documents instead")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})